/** Distributor workspace copy. Customer names, product data, and API values remain unchanged. */
const distributor = {
  'Shipment details': 'Detalles del env\u00edo',
  'This product family is no longer available to your distributor. Contact MedEffects to review product access.':
    'Esta familia de productos ya no est\u00e1 disponible para su distribuidor. Contacte a MedEffects para revisar el acceso a productos.',

  'Distributor product access': 'Acceso a productos del distribuidor',
  'Product access for {name}': 'Acceso a productos para {name}',
  'Choose the product families this distributor may offer. Customer selections can only narrow this list.':
    'Seleccione las familias de productos que puede ofrecer este distribuidor. Las selecciones de los clientes solo pueden limitar esta lista.',
  'This distributor is inactive. Product access is read-only.':
    'Este distribuidor est\u00e1 inactivo. El acceso a productos es de solo lectura.',
  'Configure product access': 'Configurar acceso a productos',
  'Updating product access...': 'Actualizando acceso a productos...',
  'Product access restrictions are active.':
    'Las restricciones de acceso a productos est\u00e1n activas.',
  'Enforcement is not enabled. Saved selections are staged and do not restrict access yet.':
    'La aplicaci\u00f3n de restricciones no est\u00e1 habilitada. Las selecciones guardadas est\u00e1n preparadas y a\u00fan no restringen el acceso.',
  'Allowed product families': 'Familias de productos permitidas',
  'No families selected. When enforcement is enabled, this blocks new purchases and orders; existing history and balances remain.':
    'No hay familias seleccionadas. Cuando se habiliten las restricciones, esto bloquear\u00e1 nuevas compras y pedidos; se conservar\u00e1n el historial y los saldos existentes.',
  'Only supported MedEffects product families are listed. Adding a catalog product does not automatically grant distributor access.':
    'Solo aparecen las familias de productos compatibles de MedEffects. Agregar un producto al cat\u00e1logo no concede acceso autom\u00e1ticamente al distribuidor.',
  'Save product access': 'Guardar acceso a productos',
  'Product access saved.': 'Acceso a productos guardado.',
  'Product access could not load. Please retry.':
    'No se pudo cargar el acceso a productos. Vuelva a intentar.',
  'Product access changed. Your edits are still here. Discard and reload before saving again.':
    'El acceso a productos cambi\u00f3. Sus cambios siguen aqu\u00ed. Desc\u00e1rtelos y vuelva a cargar antes de guardar de nuevo.',
  'Product access could not be confirmed. Your edits are still here. Discard and reload before saving again.':
    'No se pudo confirmar el acceso a productos. Sus cambios siguen aqu\u00ed. Desc\u00e1rtelos y vuelva a cargar antes de guardar de nuevo.',
  'All products available to this distributor':
    'Todos los productos disponibles para este distribuidor',
  'Some saved products are unavailable. Choose available products or All products available to this distributor to replace this restriction.':
    'Algunos productos guardados no est\u00e1n disponibles. Seleccione productos disponibles o Todos los productos disponibles para este distribuidor para reemplazar esta restricci\u00f3n.',

  'No bank units added.': 'No se agregaron unidades al banco.',
  'Awaiting processing': 'En espera de procesamiento',
  'Closing discards this unsubmitted order draft.':
    'Al cerrar se descarta este borrador de pedido sin enviar.',
  'Ordering is unavailable. Contact your distributor for assistance.':
    'Los pedidos no est\u00e1n disponibles. Contacte a su distribuidor para obtener ayuda.',
  'Submit and track orders for your clinic here.':
    'Env\u00ede y siga los pedidos de su cl\u00ednica aqu\u00ed.',
  'Order received \u2014 processing': 'Pedido recibido \u2014 en procesamiento',
  Processing: 'En proceso',
  'Order status filter': 'Filtro de estado del pedido',
  'Review your products and delivery details before submitting.':
    'Revise sus productos y los detalles de entrega antes de enviar.',
  'Customer pricing is unavailable. Contact your distributor.':
    'El precio del cliente no est\u00e1 disponible. Contacte a su distribuidor.',
  'No products are available for this clinic.':
    'No hay productos disponibles para esta cl\u00ednica.',
  'Submit order': 'Enviar pedido',
  'Review order changes': 'Revisar cambios del pedido',
  'I accept these products, quantities, delivery details and the original agreed rate.':
    'Acepto estos productos, cantidades, detalles de entrega y la tarifa original acordada.',
  'Accept and save changes': 'Aceptar y guardar cambios',
  'Processing order actions': 'Acciones del pedido en procesamiento',
  'This order has been received and is being processed. It has not been approved or sent.':
    'Este pedido se recibi\u00f3 y est\u00e1 en procesamiento. No se ha aprobado ni enviado.',
  'Reload saved order': 'Volver a cargar el pedido guardado',
  'Review processing order': 'Revisar pedido en procesamiento',
  'Cancel processing order': 'Cancelar pedido en procesamiento',
  'Cancel this order? This cannot be undone.': '\u00bfCancelar este pedido? No se puede deshacer.',
  'Confirm cancellation': 'Confirmar cancelaci\u00f3n',
  'Keep order': 'Conservar pedido',
  'Could not load the current order. Refresh your orders before trying again.':
    'No se pudo cargar el pedido actual. Actualice sus pedidos antes de volver a intentar.',
  'Cancellation could not be confirmed. Refresh your orders before trying again.':
    'No se pudo confirmar la cancelaci\u00f3n. Actualice sus pedidos antes de volver a intentar.',

  'Review card purchase {id}': 'Revisar compra con tarjeta {id}',
  'I reviewed bank, payment and accounting reconciliation and authorize resolving this payment review.':
    'Revisé la conciliación bancaria, de pago y contable y autorizo resolver esta revisión del pago.',
  'Record card payment reconciliation': 'Registrar conciliación del pago con tarjeta',
  'Card payment review': 'Revisión de pagos con tarjeta',
  'Close declined purchase': 'Cerrar compra rechazada',
  'ACH declined — purchase closed; no units credited.':
    'ACH rechazado — compra cerrada; sin unidades acreditadas.',
  'Card declined — purchase closed; no units credited.':
    'Tarjeta rechazada — compra cerrada; sin unidades acreditadas.',
  'Purchased units were credited previously. The recorded credit is retained during payment review.':
    'Las unidades se acreditaron anteriormente. El crédito registrado se conserva durante la revisión del pago.',
  'Refund under review — review the recorded bank credit separately.':
    'Reembolso en revisión — revise por separado el crédito registrado en el banco.',
  'Card purchase payment': 'Pago de compra con tarjeta',
  'Card payment options are unavailable. Retry loading them.':
    'Las opciones de pago con tarjeta no están disponibles. Intente cargarlas de nuevo.',
  'Checking card payment...': 'Consultando el pago con tarjeta...',
  'Reload card options': 'Recargar opciones de tarjeta',
  'Online card payments are unavailable. No payment has been submitted.':
    'Los pagos con tarjeta no están disponibles. No se ha enviado ningún pago.',
  'Submit sandbox card payment': 'Enviar pago de prueba con tarjeta',
  'Authorize this purchase card charge': 'Autorizar el cargo de esta compra',
  'Name on card (optional)': 'Nombre en la tarjeta (opcional)',
  'Card number': 'Número de tarjeta',
  'Expiration month (MM)': 'Mes de vencimiento (MM)',
  'Expiration year (YYYY)': 'Año de vencimiento (AAAA)',
  'Security code': 'Código de seguridad',
  'Billing ZIP code (optional)': 'Código postal de facturación (opcional)',
  'I authorize MedEffects to charge my card {amount} USD for this product-unit purchase. Units become available only after settled payment is confirmed. Refunded or disputed payments may pause spending and unsent orders for the affected product family until resolved.':
    'Autorizo a MedEffects a cargar {amount} USD a mi tarjeta por esta compra de unidades. Las unidades estarán disponibles únicamente tras confirmar la liquidación del pago. Los pagos reembolsados o disputados pueden suspender el uso del saldo y los pedidos aún no enviados de la familia de productos afectada hasta su resolución.',
  'Card payment testing is unavailable. No payment was submitted.':
    'Las pruebas de pago con tarjeta no están disponibles. No se envió ningún pago.',
  'The card details could not be verified. No payment was submitted.':
    'No se pudieron verificar los datos de la tarjeta. No se envió ningún pago.',
  'Name on card must be 30 characters or fewer.':
    'El nombre en la tarjeta debe tener 30 caracteres o menos.',
  'Enter a valid card number.': 'Ingrese un número de tarjeta válido.',
  'Enter the card expiration month and four-digit year.':
    'Ingrese el mes y el año de vencimiento de cuatro dígitos.',
  'The card expiration date has passed.': 'La tarjeta está vencida.',
  'Enter the card security code.': 'Ingrese el código de seguridad de la tarjeta.',
  'Enter a valid billing ZIP code.': 'Ingrese un código postal de facturación válido.',
  'Select the checkbox to authorize this card purchase.':
    'Marque la casilla para autorizar esta compra con tarjeta.',
  'Card settled. Purchased units were added to your bank.':
    'Pago con tarjeta liquidado. Las unidades compradas se agregaron al banco.',
  'Card return reconciled. Review the recorded bank credit separately.':
    'Devolución de tarjeta conciliada. Revise por separado el crédito registrado en el banco.',
  'Card refund or dispute recorded — review required.':
    'Reembolso o disputa de tarjeta registrado — requiere revisión.',
  'Card settled — units credited': 'Pago con tarjeta liquidado — unidades acreditadas',
  'Card authorized or captured — not settled; no units credited.':
    'Tarjeta autorizada o capturada — sin liquidar; sin unidades acreditadas.',
  'Card payment verified — bank credit pending.':
    'Pago con tarjeta verificado — crédito al banco pendiente.',
  'Card declined — no units credited.': 'Tarjeta rechazada — sin unidades acreditadas.',
  'Card return review': 'Revisión de devoluciones de tarjeta',
  'Refresh Card reviews': 'Actualizar revisiones de tarjeta',
  'Loading Card reviews...': 'Cargando revisiones de tarjeta...',
  'No Card attempts need observation or return review.':
    'No hay intentos con tarjeta que requieran observación o revisión de devoluciones.',
  'Showing {count} Card records. Funding without a linked bank entry is not a unit credit.':
    'Se muestran {count} registros de tarjeta. Un pago sin una entrada vinculada en el banco no acredita unidades.',
  'Card review records are unavailable. Reload before continuing.':
    'Los registros de revisión de tarjeta no están disponibles. Recargue antes de continuar.',
  'Card review pages': 'Páginas de revisión de tarjeta',
  'Record verified chargeback': 'Registrar contracargo verificado',
  'Verified card chargeback': 'Contracargo de tarjeta verificado',
  'Verify the provider case against this payment reference. Do not paste a notice or card details. No refund is initiated and no units are deducted.':
    'Verifique el caso del proveedor con esta referencia de pago. No pegue avisos ni datos de tarjeta. No se inicia ningún reembolso ni se deducen unidades.',
  'Payment reference': 'Referencia del pago',
  'Provider case reference': 'Referencia del caso del proveedor',
  'Chargeback amount (USD)': 'Importe del contracargo (USD)',
  'Provider notice date': 'Fecha del aviso del proveedor',
  'I verified the chargeback case, payment reference, amount and date in the provider records.':
    'Verifiqué el caso de contracargo, la referencia del pago, el importe y la fecha en los registros del proveedor.',
  'Recover same chargeback request': 'Recuperar la misma solicitud de contracargo',
  'Chargeback result is unconfirmed. Recover the same request before recording another.':
    'El resultado del contracargo no está confirmado. Recupere la misma solicitud antes de registrar otra.',
  'Sale amount': 'Importe de venta',
  'Product subtotal': 'Subtotal de productos',
  'Amount unavailable': 'Importe no disponible',
  'Products only. This is not an invoice or a balance due.':
    'Solo productos. No es una factura ni un saldo pendiente.',
  'Product line amounts': 'Importes de productos por renglón',
  'Previous sale amounts': 'Importes de venta anteriores',
  'Revision {revision}': 'Revisión {revision}',
  'Customer unavailable': 'Cliente no disponible',
  'Export orders': 'Exportar pedidos',
  'Could not export orders. Please try again.':
    'No se pudieron exportar los pedidos. Inténtelo de nuevo.',
  'Ordering disabled': 'Pedidos deshabilitados',
  'Selected distributor': 'Distribuidor seleccionado',
  'IVR totals are unavailable. The list still uses the selected filters.':
    'Los totales de IVR no están disponibles. La lista sigue usando los filtros seleccionados.',
  'Download orders matching the current portal, distributor, status and search filters during the selected dates. Both dates are included.':
    'Descargue los pedidos que coincidan con los filtros actuales de portal, distribuidor, estado y búsqueda durante las fechas seleccionadas. Ambas fechas están incluidas.',
  'Customer saved, but setup could not refresh. Refresh setup before continuing.':
    'Cliente guardado, pero no se pudo actualizar la configuraci\u00f3n. Actualice la configuraci\u00f3n antes de continuar.',
  'Manage distributor customers': 'Administrar clientes del distribuidor',
  'Admin customer assistance': 'Asistencia administrativa a clientes',
  'Manage customers for {name}': 'Administrar clientes de {name}',
  'Admin changes apply only to this distributor. Direct MedEffects clinics and other distributors are not changed.':
    'Los cambios administrativos solo se aplican a este distribuidor. No cambian las cl\u00ednicas directas de MedEffects ni otros distribuidores.',
  'Could not load distributor customers. Please retry.':
    'No se pudieron cargar los clientes del distribuidor. Int\u00e9ntelo de nuevo.',
  'Discard changes to reload the latest saved settings before saving again.':
    'Descarte los cambios para volver a cargar los ajustes guardados antes de guardar de nuevo.',
  "This customer list is separate from direct MedEffects clinics. Active master logins share this distributor's customers and product bank. Clinic logins see only their own distributor clinic records and cannot access the product bank.":
    'Esta lista de clientes est\u00e1 separada de las cl\u00ednicas directas de MedEffects. Los accesos de distribuidores principales activos comparten los clientes y el banco de productos del distribuidor. Los accesos de cl\u00ednicas solo ven los registros de su propia cl\u00ednica del distribuidor y no pueden acceder al banco de productos.',
  'Filter by portal': 'Filtrar por portal',
  'All portals': 'Todos los portales',
  'Direct MedEffects': 'MedEffects directo',
  Distributor: 'Distribuidor',
  'Filter by distributor': 'Filtrar por distribuidor',
  'All distributors': 'Todos los distribuidores',
  PORTAL: 'TIPO DE PORTAL',
  '{name}: distributor customers and product bank':
    '{name}: clientes del distribuidor y banco de productos',
  '{name}: own distributor clinic records only':
    '{name}: solo los registros de su propia cl\u00ednica del distribuidor',
  'No distributor bound - review this login': 'Sin distribuidor asignado: revise este acceso',
  'Distributor names are unavailable. The list still uses the selected portal filter.':
    'Los nombres de distribuidores no est\u00e1n disponibles. La lista sigue usando el filtro de portal seleccionado.',

  'QuickBooks-linked clinic': 'Cl\u00ednica vinculada a QuickBooks',
  Record: 'Registro',
  'Page {page} of {pages}': 'P\u00e1gina {page} de {pages}',
  Tracking: 'Seguimiento',
  'Rate per unit': 'Precio por unidad',
  'Ordering enabled': 'Pedidos habilitados',
  'Allowed products': 'Productos permitidos',
  'Product list unavailable. Other settings can still be saved.':
    'La lista de productos no est\u00e1 disponible. Puede guardar los dem\u00e1s ajustes.',
  'Some saved products are unavailable. Choose active products or All active products to replace this restriction.':
    'Algunos productos guardados no est\u00e1n disponibles. Elija productos activos o Todos los productos activos para reemplazar esta restricci\u00f3n.',
  'All active products': 'Todos los productos activos',
  'Save settings': 'Guardar ajustes',
  'Unsaved changes': 'Cambios sin guardar',
  'Clinic users': 'Usuarios de la cl\u00ednica',
  'Create a clinic login with a temporary password. Share it privately with the user. They must accept the Terms and Privacy Policy themselves.':
    'Cree un acceso a la cl\u00ednica con una contrase\u00f1a temporal. Comp\u00e1rtala en privado con el usuario. El usuario debe aceptar los T\u00e9rminos y la Pol\u00edtica de privacidad personalmente.',
  'Loading clinic users...': 'Cargando usuarios de la cl\u00ednica...',
  'No clinic users yet.': 'A\u00fan no hay usuarios de la cl\u00ednica.',
  'Pending acceptance': 'Aceptaci\u00f3n pendiente',
  'Reset password': 'Restablecer contrase\u00f1a',
  Deactivate: 'Desactivar',
  Reactivate: 'Reactivar',
  'New temporary password': 'Nueva contrase\u00f1a temporal',
  'Create clinic login': 'Crear acceso a la cl\u00ednica',
  'Temporary password': 'Contrase\u00f1a temporal',
  'Create login': 'Crear acceso',
  'Could not load clinic users. Please try again.':
    'No se pudieron cargar los usuarios de la cl\u00ednica. Int\u00e9ntelo de nuevo.',
  'Clinic login created. The user must accept the Terms and Privacy Policy after signing in.':
    'Acceso a la cl\u00ednica creado. El usuario debe aceptar los T\u00e9rminos y la Pol\u00edtica de privacidad al iniciar sesi\u00f3n.',
  'Account creation could not be confirmed. Refresh the list before trying again.':
    'No se pudo confirmar la creaci\u00f3n de la cuenta. Actualice la lista antes de intentarlo de nuevo.',
  'Account status updated.': 'Estado de la cuenta actualizado.',
  'Password reset. All prior sessions were revoked.':
    'Contrase\u00f1a restablecida. Se revocaron todas las sesiones anteriores.',
  'Password reset could not be confirmed. Review the account before trying again.':
    'No se pudo confirmar el restablecimiento de la contrase\u00f1a. Revise la cuenta antes de intentarlo de nuevo.',
  'Use 12-72 characters with uppercase and lowercase letters, a number, and one of @$!%*?&#. Only letters, numbers, and these symbols are allowed.':
    'Use de 12 a 72 caracteres con letras may\u00fasculas y min\u00fasculas, un n\u00famero y uno de estos s\u00edmbolos: @$!%*?&#. Solo se permiten letras, n\u00fameros y estos s\u00edmbolos.',
  'Wait for the current settings save to finish.':
    'Espere a que termine de guardarse la configuraci\u00f3n actual.',
  'Save or discard your current edits before opening another clinic.':
    'Guarde o descarte sus cambios antes de abrir otra cl\u00ednica.',
  'Save or discard your current edits before creating another clinic.':
    'Guarde o descarte sus cambios antes de crear otra cl\u00ednica.',
  'Enter a clinic name and a complete delivery address, or leave the address blank.':
    'Ingrese el nombre de la cl\u00ednica y una direcci\u00f3n de entrega completa, o deje la direcci\u00f3n en blanco.',
  'Clinic created.': 'Cl\u00ednica creada.',
  'Clinic creation could not be confirmed. Check the clinic list before trying again.':
    'No se pudo confirmar la creaci\u00f3n de la cl\u00ednica. Revise la lista de cl\u00ednicas antes de intentarlo de nuevo.',
  'Enter valid nonnegative amounts.': 'Ingrese importes v\u00e1lidos que no sean negativos.',
  'Enter a complete delivery address or clear all its fields.':
    'Ingrese una direcci\u00f3n de entrega completa o borre todos sus campos.',
  'Settings saved.': 'Ajustes guardados.',
  'Settings changed or could not be confirmed. Review the latest saved values before trying again. Your edits are still here.':
    'Los ajustes cambiaron o no se pudieron confirmar. Revise los \u00faltimos valores guardados antes de intentarlo de nuevo. Sus cambios siguen aqu\u00ed.',
  'Settings could not be confirmed. Your edits are still here. Reload the clinic before trying again.':
    'No se pudieron confirmar los ajustes. Sus cambios siguen aqu\u00ed. Recargue la cl\u00ednica antes de intentarlo de nuevo.',
  'Distributor order': 'Pedido del distribuidor',
  'New distributor order': 'Nuevo pedido del distribuidor',
  'Reload choices': 'Recargar opciones',
  'Loading order choices...': 'Cargando opciones del pedido...',
  'Ordering is disabled for this clinic.':
    'Los pedidos est\u00e1n deshabilitados para esta cl\u00ednica.',
  'No BLS bank products are available for this clinic.':
    'No hay productos del banco BLS disponibles para esta cl\u00ednica.',
  Product: 'Producto',
  'Choose product': 'Elegir producto',
  Size: 'Tama\u00f1o',
  Quantity: 'Cantidad',
  'Add product': 'Agregar producto',
  'Calculated delivery date': 'Fecha de entrega calculada',
  'Checking...': 'Verificando...',
  'Preferred carrier': 'Transportista preferido',
  'Customer PO (optional)': 'Orden de compra del cliente (opcional)',
  'Submit funded order': 'Enviar pedido con saldo del banco',
  'Order choices are unavailable. Please retry.':
    'Las opciones del pedido no est\u00e1n disponibles. Int\u00e9ntelo de nuevo.',
  'Customer pricing is unavailable. Set a customer price before ordering.':
    'El precio del cliente no est\u00e1 disponible. Configure un precio para el cliente antes de hacer el pedido.',
  'Customer pricing changed. Review the updated rate before submitting again.':
    'El precio del cliente cambi\u00f3. Revise el precio actualizado antes de enviar el pedido de nuevo.',
  'Delivery date is unavailable. Please retry.':
    'La fecha de entrega no est\u00e1 disponible. Int\u00e9ntelo de nuevo.',
  'Choose products and whole quantities, then confirm the calculated delivery date.':
    'Elija productos y cantidades enteras; luego confirme la fecha de entrega calculada.',
  'A product size could not be verified. Reload the order choices.':
    'No se pudo verificar el tama\u00f1o de un producto. Recargue las opciones del pedido.',
  'Shipping availability changed. Review the updated delivery date before submitting again.':
    'La disponibilidad de env\u00edo cambi\u00f3. Revise la fecha de entrega actualizada antes de enviarlo de nuevo.',
  'Order could not be confirmed. Check your orders, then retry with the same request. No new request key was created.':
    'No se pudo confirmar el pedido. Revise sus pedidos y vuelva a intentar la misma solicitud. No se cre\u00f3 una nueva clave de solicitud.',
  '{orderId} {status}. BLS delivery: {deliveryStatus}.':
    '{orderId} {status}. Env\u00edo a BLS: {deliveryStatus}.',
  '{family} has {available} units; this order needs {required}.':
    '{family} tiene {available} unidades; este pedido necesita {required}.',
  approved: 'aprobado',
  shipped: 'enviado',
  cancelled: 'cancelado',
  sent: 'enviado',
  needs_review: 'necesita revisi\u00f3n',
  'First Overnight - 8:30AM': 'Entrega al d\u00eda siguiente - 8:30 a. m.',
  'Priority Overnight - 10:30AM': 'Entrega prioritaria al d\u00eda siguiente - 10:30 a. m.',
  'Standard Overnight - 4PM': 'Entrega est\u00e1ndar al d\u00eda siguiente - 4 p. m.',
  '2Day AM - 8:30AM': 'Entrega en 2 d\u00edas - 8:30 a. m.',
  '2Day Priority Overnight - 10:30AM': 'Entrega prioritaria en 2 d\u00edas - 10:30 a. m.',
  '2Day Standard - 4PM': 'Entrega est\u00e1ndar en 2 d\u00edas - 4 p. m.',
  'Balances use product units, not physical square centimeters.':
    'Los saldos usan unidades de producto, no cent\u00edmetros cuadrados f\u00edsicos.',
  'Loading bank...': 'Cargando banco...',
  'Loading bank history...': 'Cargando historial del banco...',
  'Bank information is unavailable. Please try again.':
    'La informaci\u00f3n del banco no est\u00e1 disponible. Int\u00e9ntelo de nuevo.',
  'Bank history is unavailable. Please try again.':
    'El historial del banco no est\u00e1 disponible. Int\u00e9ntelo de nuevo.',
  'No product families are assigned to this bank yet.':
    'A\u00fan no hay familias de productos asignadas a este banco.',
  'units available': 'unidades disponibles',
  'No active products mapped': 'No hay productos activos vinculados',
  'Check units': 'Calcular unidades',
  'Choose a product and enter a known size and positive whole quantity.':
    'Elija un producto e ingrese un tama\u00f1o v\u00e1lido y una cantidad entera positiva.',
  'The product or size could not be verified. No units were calculated.':
    'No se pudo verificar el producto o el tama\u00f1o. No se calcularon unidades.',
  'product units': 'unidades de producto',
  'per piece': 'por pieza',
  'Bank history': 'Historial del banco',
  'Product family': 'Familia de productos',
  'All families': 'Todas las familias',
  'No bank transactions yet.': 'A\u00fan no hay transacciones del banco.',
  units: 'unidades',
  '{units} units remaining': '{units} unidades restantes',
  purchase: 'Compra',
  correction: 'Correcci\u00f3n',
  debit: 'Deducci\u00f3n',
  reversal: 'Reversi\u00f3n',
  'Distributor purchase settings': 'Configuraci\u00f3n de compras del distribuidor',
  'Purchase settings for {name}': 'Configuraci\u00f3n de compras para {name}',
  'Use an existing MedEffects client price. This reference does not copy customers, grant client access, or change their price.':
    'Use un precio de cliente existente de MedEffects. Esta referencia no copia clientes, no otorga acceso a sus datos ni cambia su precio.',
  'These settings control purchase policy only. They do not enable live payments, charge money, or add bank units.':
    'Estos ajustes solo controlan la pol\u00edtica de compras. No habilitan pagos reales, no cobran dinero ni agregan unidades al banco.',
  'Configure purchases': 'Configurar compras',
  'Purchase settings could not load. Please retry.':
    'No se pudo cargar la configuraci\u00f3n de compras. Int\u00e9ntelo de nuevo.',
  'Choose an available pricing account, or select Not configured.':
    'Elija una cuenta de precios disponible o seleccione No configurado.',
  'Purchase settings saved.': 'Configuraci\u00f3n de compras guardada.',
  'Purchase settings changed. Your edits are still here. Discard and reload before saving again.':
    'La configuraci\u00f3n de compras cambi\u00f3. Sus cambios siguen aqu\u00ed. Desc\u00e1rtelos y vuelva a cargar antes de guardar otra vez.',
  'Purchase settings could not be confirmed. Your edits are still here. Discard and reload before saving again.':
    'No se pudo confirmar la configuraci\u00f3n de compras. Sus cambios siguen aqu\u00ed. Desc\u00e1rtelos y vuelva a cargar antes de guardar otra vez.',
  'Updating purchase settings...': 'Actualizando la configuraci\u00f3n de compras...',
  'MedEffects pricing account': 'Cuenta de precios de MedEffects',
  'Pricing account unavailable': 'Cuenta de precios no disponible',
  'Current purchase rate': 'Precio de compra actual',
  '{rate} USD per unit': '{rate} USD por unidad',
  'Purchase pricing unavailable': 'Precio de compra no disponible',
  'Prices are read-only here. Quotes recheck the current client price before purchase.':
    'Los precios son de solo lectura aqu\u00ed. Las cotizaciones verifican el precio actual del cliente antes de comprar.',
  'Allowed purchase methods': 'M\u00e9todos de compra permitidos',
  Wire: 'Transferencia bancaria',
  'Credit card': 'Tarjeta de cr\u00e9dito',
  'Save purchase settings': 'Guardar configuraci\u00f3n de compras',
  'Discard and reload': 'Descartar y volver a cargar',
  'This distributor is inactive. Purchase settings are read-only.':
    'Este distribuidor est\u00e1 inactivo. La configuraci\u00f3n de compras es de solo lectura.',
  'Purchase product units': 'Comprar unidades de producto',
  'Payments are not available yet. You can save a purchase draft; no money is charged and no units are added.':
    'Los pagos a\u00fan no est\u00e1n disponibles. Puede guardar un borrador de compra; no se cobra dinero ni se agregan unidades.',
  'Purchase drafts are unavailable. Retry recovery before creating a draft.':
    'Los borradores de compra no est\u00e1n disponibles. Intente recuperarlos antes de crear otro.',
  'Purchase draft saved. No payment was taken and no units were added.':
    'Borrador de compra guardado. No se cobr\u00f3 ning\u00fan pago ni se agregaron unidades.',
  'Saved purchase draft recovered. No payment was taken and no units were added.':
    'Borrador de compra guardado recuperado. No se cobr\u00f3 ning\u00fan pago ni se agregaron unidades.',
  'Purchase draft closed. No payment was taken and no units were added.':
    'Borrador de compra cerrado. No se cobr\u00f3 ning\u00fan pago ni se agregaron unidades.',
  'Choose an available product family, whole units and allowed method.':
    'Elija una familia de productos disponible, unidades enteras y un m\u00e9todo permitido.',
  'A current purchase quote is unavailable. Review the fields and try again.':
    'No hay una cotizaci\u00f3n de compra vigente disponible. Revise los campos e int\u00e9ntelo de nuevo.',
  'This draft could not be confirmed. Recover it before starting another. No payment was initiated.':
    'No se pudo confirmar este borrador. Recup\u00e9relo antes de iniciar otro. No se inici\u00f3 ning\u00fan pago.',
  'A secure request key is unavailable. Reload before saving.':
    'No hay una clave de solicitud segura disponible. Vuelva a cargar antes de guardar.',
  'Purchase pricing or methods changed. Request and review a new quote before saving.':
    'El precio o los m\u00e9todos de compra cambiaron. Solicite y revise una nueva cotizaci\u00f3n antes de guardar.',
  'Draft closure could not be confirmed. Review this saved draft before trying again.':
    'No se pudo confirmar el cierre. Revise este borrador guardado antes de intentarlo de nuevo.',
  'Checking purchase draft...': 'Verificando borrador de compra...',
  'Retry recovery': 'Reintentar recuperaci\u00f3n',
  'Refresh purchase options': 'Actualizar opciones de compra',
  'Purchase product family': 'Familia de productos para comprar',
  'Choose product family': 'Elija una familia de productos',
  'Units to purchase': 'Unidades para comprar',
  Units: 'Unidades',
  'Purchase method': 'M\u00e9todo de compra',
  'Choose method': 'Elija un m\u00e9todo',
  Unavailable: 'No disponible',
  'No purchase methods are configured. Contact MedEffects.':
    'No hay m\u00e9todos de compra configurados. Comun\u00edquese con MedEffects.',
  'Review purchase quote': 'Revisar cotizaci\u00f3n de compra',
  'Saved purchase draft': 'Borrador de compra guardado',
  'Purchase quote': 'Cotizaci\u00f3n de compra',
  'Draft saved — payment not started': 'Borrador guardado: pago no iniciado',
  'Draft closed — payment not started': 'Borrador cerrado: pago no iniciado',
  'No payment taken. No bank units added.':
    'No se cobr\u00f3 ning\u00fan pago ni se agregaron unidades al banco.',
  'Draft ID': 'ID del borrador',
  'I understand this saves a draft only, with no payment or bank credit.':
    'Entiendo que esto solo guarda un borrador, sin pago ni cr\u00e9dito al banco.',
  'Save purchase draft': 'Guardar borrador de compra',
  'Recover saved draft': 'Recuperar borrador guardado',
  'Retry same draft': 'Reintentar el mismo borrador',
  'Close draft': 'Cerrar borrador',
  'Purchase draft history': 'Historial de borradores de compra',
  'Saved drafts are not payments. They do not change your available bank balance.':
    'Los borradores guardados no son pagos. No cambian el saldo disponible del banco.',
  'Purchase draft history is unavailable. Please retry.':
    'El historial de borradores no est\u00e1 disponible. Int\u00e9ntelo de nuevo.',
  'This purchase draft could not be opened. Please retry.':
    'No se pudo abrir este borrador de compra. Int\u00e9ntelo de nuevo.',
  'Loading purchase drafts...': 'Cargando borradores de compra...',
  'No purchase drafts yet.': 'A\u00fan no hay borradores de compra.',
  'View purchase draft {id}': 'Ver borrador de compra {id}',
  'Purchase draft pages': 'P\u00e1ginas de borradores de compra',
  'Opening purchase draft...': 'Abriendo borrador de compra...',
  'Purchase draft detail': 'Detalles del borrador de compra',
  'Online payments are not available yet. Saving a draft does not send funds. Wire purchases add units only after MedEffects confirms cleared funds.':
    'Los pagos en l\u00ednea a\u00fan no est\u00e1n disponibles. Guardar un borrador no env\u00eda fondos. Las compras por transferencia agregan unidades solo cuando MedEffects confirma los fondos liquidados.',
  'Wire confirmed — units credited': 'Transferencia confirmada — unidades acreditadas',
  'Wire confirmed. Purchased units were added to your bank.':
    'Transferencia confirmada. Las unidades compradas se agregaron a su banco.',
  'Bank entry ID': 'ID del movimiento bancario',
  'Refresh purchase status': 'Actualizar estado de compra',
  'Start another purchase': 'Iniciar otra compra',
  'Purchase status could not be confirmed. Refresh it before relying on a credit.':
    'No se pudo confirmar el estado de compra. Actual\u00edcelo antes de contar con el cr\u00e9dito.',
  'Purchase history': 'Historial de compras',
  'Purchase ID': 'ID de compra',
  'View purchase receipt {id}': 'Ver comprobante de compra {id}',
  'Purchase receipt detail': 'Detalles del comprobante de compra',
  'Refresh purchases': 'Actualizar compras',
  'Refreshing bank balance...': 'Actualizando saldo del banco...',
  'Showing the last loaded balance. Refresh is required to confirm available units.':
    'Se muestra el \u00faltimo saldo cargado. Actualice para confirmar las unidades disponibles.',
  'Drafts do not add units. Confirmed wire purchases show their bank credit receipt.':
    'Los borradores no agregan unidades. Las compras por transferencia confirmadas muestran su comprobante de cr\u00e9dito bancario.',
  'Wire payment instructions': 'Instrucciones para transferencia bancaria',
  'Use the exact saved wire purchase amount. Units are added only after MedEffects verifies cleared funds. No wire is sent by this app.':
    'Use el importe exacto de la compra por transferencia guardada. Las unidades se agregan solo cuando MedEffects verifica los fondos liquidados. Esta aplicaci\u00f3n no env\u00eda transferencias.',
  'Wire instructions are unavailable. Contact MedEffects before sending funds.':
    'Las instrucciones de transferencia no est\u00e1n disponibles. Comun\u00edquese con MedEffects antes de enviar fondos.',
  'Loading wire instructions...': 'Cargando instrucciones de transferencia...',
  'TEST ONLY — do not send funds.': 'SOLO PRUEBA — no env\u00ede fondos.',
  'A saved draft does not send a wire or confirm funds. Units are added only after MedEffects verifies cleared funds at the bank.':
    'Guardar un borrador no env\u00eda una transferencia ni confirma fondos. Las unidades se agregan solo cuando MedEffects verifica los fondos liquidados en el banco.',
  'Saving a draft does not send funds. Units are available only after a confirmed bank credit.':
    'Guardar un borrador no envía fondos. Las unidades están disponibles solo después de un crédito bancario confirmado.',
  'ACH purchase payment': 'Pago de compra por ACH',
  'Payment was not submitted. Reload payment options and review the purchase before authorizing again.':
    'No se envió el pago. Vuelva a cargar las opciones y revise la compra antes de autorizar nuevamente.',
  'Sandbox test only. This checkout does not add bank units or enable live payments.':
    'Solo prueba de sandbox. Este pago no agrega unidades al banco ni habilita pagos reales.',
  'ACH payment options are unavailable. Retry loading them.':
    'Las opciones de pago ACH no están disponibles. Vuelva a cargarlas.',
  'Payment status is unconfirmed. Do not submit again. Refresh payment status or contact MedEffects. No bank units have been added.':
    'El estado del pago no está confirmado. No vuelva a enviarlo. Actualice el estado o contacte a MedEffects. No se agregaron unidades al banco.',
  'The account details could not be verified. No payment was submitted.':
    'No se pudieron verificar los datos de la cuenta. No se envió ningún pago.',
  'Checking ACH payment...': 'Comprobando pago ACH...',
  'Do not submit another payment for this purchase. No bank units have been added.':
    'No envíe otro pago para esta compra. No se agregaron unidades al banco.',
  'Refresh payment status': 'Actualizar estado del pago',
  'Reload ACH options': 'Volver a cargar opciones ACH',
  'Online ACH payments are unavailable. No payment has been submitted.':
    'Los pagos ACH en línea no están disponibles. No se ha enviado ningún pago.',
  'Authorize this purchase debit': 'Autorizar el débito de esta compra',
  'Submit sandbox ACH payment': 'Enviar pago ACH de sandbox',
  'I authorize MedEffects to debit my bank account for {amount} USD for this product-unit purchase. Units become available only after cleared payment is confirmed. If payment is returned, spending from the affected product family may be blocked until resolved.':
    'Autorizo a MedEffects a debitar {amount} USD de mi cuenta bancaria para esta compra de unidades de producto. Las unidades estarán disponibles solo después de confirmar el pago liquidado. Si el pago es devuelto, el uso de la familia de productos afectada puede bloquearse hasta que se resuelva.',
  'Payment request processing — no units credited.':
    'Solicitud de pago en proceso — sin unidades acreditadas.',
  'ACH pending — no units credited.': 'ACH pendiente — sin unidades acreditadas.',
  'ACH payment verified — bank credit pending.':
    'Pago ACH verificado — crédito al banco pendiente.',
  'Payment outcome unknown — do not submit again.':
    'Resultado del pago desconocido — no vuelva a enviarlo.',
  'ACH declined — no units credited.': 'ACH rechazado — sin unidades acreditadas.',
  'Payment unavailable — review required.': 'Pago no disponible — requiere revisión.',
  'ACH returned — contact MedEffects.': 'ACH devuelto — contacte a MedEffects.',
  'ACH payment review reconciled — recorded credit retained.':
    'Revisión del pago ACH conciliada — se conserva el crédito registrado.',
  'ACH refund or return recorded — review required.':
    'Reembolso o devolución de ACH registrado — se requiere revisión.',
  'Review ACH payment {id}': 'Revisar pago ACH {id}',
  'Record ACH payment reconciliation': 'Registrar conciliación del pago ACH',
  'ACH cleared — units credited': 'ACH liquidado — unidades acreditadas',
  'ACH returned — review required; recorded credit retained.':
    'ACH devuelto — requiere revisión; se conserva el crédito registrado.',
  'Units credited — payment status currently unconfirmed.':
    'Unidades acreditadas — estado del pago aún sin confirmar.',
  'ACH cleared. Purchased units were added to your bank.':
    'ACH liquidado. Las unidades compradas se agregaron a su banco.',
  'Purchased units were credited previously. The recorded credit is retained after this return.':
    'Las unidades se acreditaron anteriormente. El crédito registrado se conserva después de esta devolución.',
  'Drafts do not add units. Credited purchases retain their bank entry, including after a return.':
    'Los borradores no agregan unidades. Las compras acreditadas conservan su asiento en el banco, incluso después de una devolución.',
  'Spending paused for this product family. Contact MedEffects for review.':
    'Uso pausado para esta familia de productos. Contacte a MedEffects para revisión.',
  'Recorded balance: {units} units': 'Saldo registrado: {units} unidades',
  'Payment status is unconfirmed. Do not submit again. Refresh payment status or contact MedEffects. Review the saved bank credit separately.':
    'El estado del pago no está confirmado. No lo envíe otra vez. Actualice el estado o contacte a MedEffects. Revise por separado el crédito registrado en el banco.',
  'Do not submit another payment for this purchase. Review the saved bank credit separately.':
    'No envíe otro pago para esta compra. Revise por separado el crédito registrado en el banco.',
  'ACH return review': 'Revisión de devolución ACH',
  'Review bank, payment and accounting records separately. This action only clears the affected family restriction after audited reconciliation; it changes no units or money.':
    'Revise por separado los registros bancarios, de pago y contables. Esta acción solo elimina la restricción de la familia afectada tras una conciliación auditada; no modifica unidades ni dinero.',
  'Refresh ACH reviews': 'Actualizar revisiones ACH',
  'Loading ACH reviews...': 'Cargando revisiones ACH...',
  'ACH review records are unavailable. Reload before continuing.':
    'Los registros de revisión ACH no están disponibles. Vuelva a cargar antes de continuar.',
  'Review result is unconfirmed. Retry the same review request to recover its receipt.':
    'El resultado de la revisión no está confirmado. Reintente la misma solicitud para recuperar su comprobante.',
  'A secure request key is unavailable. Reload before reviewing.':
    'No hay una clave de solicitud segura disponible. Vuelva a cargar antes de revisar.',
  'Reconciliation recorded. This review changed no units or money.':
    'Conciliación registrada. Esta revisión no modificó unidades ni dinero.',
  'No ACH attempts need observation or return review.':
    'No hay intentos ACH pendientes de observación o revisión de devolución.',
  'Showing {count} ACH records. Funding without a linked bank entry is not a unit credit.':
    'Se muestran {count} registros ACH. Los fondos sin un asiento bancario vinculado no constituyen un crédito de unidades.',
  'Family spending paused; affected unsent orders remain paused.':
    'Uso de la familia pausado; los pedidos afectados aún no enviados permanecen pausados.',
  'Return reconciliation recorded.': 'Conciliación de devolución registrada.',
  'No return restriction recorded.': 'No hay una restricción por devolución registrada.',
  'Review returned purchase {id}': 'Revisar compra devuelta {id}',
  'Reconciliation reason': 'Motivo de conciliación',
  'I reviewed bank, payment and accounting reconciliation and authorize clearing this family restriction.':
    'Revisé la conciliación bancaria, de pago y contable y autorizo eliminar esta restricción de familia.',
  'Recover same reconciliation request': 'Recuperar la misma solicitud de conciliación',
  'Record reconciliation and clear restriction': 'Registrar conciliación y eliminar restricción',
  'ACH review pages': 'Páginas de revisión ACH',
  'Purchase payment monitor health': 'Estado del monitor de pagos',
  'Monitor health does not enable payments or prove merchant or accounting readiness.':
    'El estado del monitor no habilita pagos ni confirma la preparación comercial o contable.',
  'Refresh payment monitor health': 'Actualizar estado del monitor de pagos',
  'Loading payment monitor health...': 'Cargando estado del monitor de pagos...',
  'Payment monitor health is unavailable. Readiness is unconfirmed.':
    'El estado del monitor de pagos no está disponible. La preparación no está confirmada.',
  'Owner or interval not configured': 'Responsable o intervalo sin configurar',
  'No successful monitor run verified': 'No se verificó ninguna ejecución correcta del monitor',
  'Monitor stalled': 'Monitor detenido',
  'Monitor failed': 'Monitor con errores',
  'Manual review required': 'Requiere revisión manual',
  'Monitor healthy': 'Monitor funcionando correctamente',
  'Monitor ready': 'Monitor preparado',
  'Activation blocked': 'Activación bloqueada',
  'Operational owner': 'Responsable operativo',
  Unassigned: 'Sin asignar',
  'Monitor interval (minutes)': 'Intervalo del monitor (minutos)',
  'Observation backlog': 'Observaciones pendientes',
  'Payment observation reviews': 'Revisiones de observación de pagos',
  'Earlier reconciliation recovered. A newer return review remains open. Family spending remains paused. No units or money changed.':
    'Se recuperó la conciliación anterior. Sigue abierta una revisión de devolución más reciente. El uso del saldo de la familia sigue suspendido. No se modificaron unidades ni dinero.',
  'Last monitor run': 'Última ejecución del monitor',
  'Last successful observation': 'Última observación correcta',
  'Last monitor error': 'Último error del monitor',
  'Oldest pending observation': 'Observación pendiente más antigua',
  'ACH return reconciled — recorded credit retained.':
    'Devolución ACH conciliada — se conserva el crédito registrado.',
  'ACH return reconciled — no units credited.':
    'Devolución ACH conciliada — sin unidades acreditadas.',
  'Review bank, payment and accounting records separately. This action records audited return reconciliation. Family spending resumes only when all return reviews are resolved. It changes no units or money.':
    'Revise por separado los registros bancarios, de pago y contables. Esta acción registra una conciliación de devolución auditada. El uso de la familia se reanuda solo cuando se resuelven todas las revisiones de devolución. No modifica unidades ni dinero.',
  'I reviewed bank, payment and accounting reconciliation and authorize resolving this returned purchase.':
    'Revisé la conciliación bancaria, de pago y contable y autorizo resolver esta compra devuelta.',
  'Record return reconciliation': 'Registrar conciliación de devolución',
  'Reconciliation recorded. Family spending remains paused for another return review. No units or money changed.':
    'Conciliación registrada. El uso de la familia sigue pausado por otra revisión de devolución. No se modificaron unidades ni dinero.',
  'Awaiting available product units': 'En espera de unidades de producto disponibles',
  'Order requires review before release': 'El pedido requiere revisión antes de su procesamiento',
  'Delivery date updated': 'Fecha de entrega actualizada',
  'Your requested delivery date moved from {previous} to {current} using the same shipping service. Delivery times are not guaranteed.':
    'La fecha de entrega solicitada cambió del {previous} al {current} con el mismo servicio de envío. Los plazos de entrega no están garantizados.',
  'Apply filters': 'Aplicar filtros',
  'Created from (UTC)': 'Creado desde (UTC)',
  'Created through (UTC)': 'Creado hasta (UTC)',
  'Date (UTC)': 'Fecha (UTC)',
  'Search order or tracking number': 'Buscar pedido o número de seguimiento',
  'No records match these filters.': 'Ningún registro coincide con estos filtros.',
  'Activity table': 'Tabla de actividad',
  'IVR ID': 'ID de IVR',
  'Order ID': 'ID del pedido',
  'Showing {count} of {total}': 'Mostrando {count} de {total}',
  'Status filter': 'Filtro de estado',
};

export default distributor;
